module.exports = __webpack_public_path__ + "img/mainconthelp.5dc2474d.png";